import { SvgIcon, SvgIconProps } from '@mui/material';

const TopicChatIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.289062" width="20" height="20" rx="10" fill="#242424" />
      <path
        d="M15.6798 9.64104C15.6798 6.3548 13.1298 4.12207 10.2925 4.12207C7.48513 4.12207 4.90523 6.30691 4.90523 9.67695C4.54608 9.88047 4.30664 10.2636 4.30664 10.7065V11.9037C4.30664 12.5621 4.84537 13.1009 5.50381 13.1009C5.83304 13.1009 6.1024 12.8315 6.1024 12.5023V9.62308C6.1024 7.33049 7.86823 5.32523 10.1608 5.25938C12.5312 5.18755 14.4826 7.09106 14.4826 9.44949V13.6995H10.2925C9.96328 13.6995 9.69392 13.9688 9.69392 14.298C9.69392 14.6273 9.96328 14.8966 10.2925 14.8966H14.4826C15.1411 14.8966 15.6798 14.3579 15.6798 13.6995V12.9692C16.0329 12.7836 16.2784 12.4185 16.2784 11.9875V10.6107C16.2784 10.1917 16.0329 9.8266 15.6798 9.64104Z"
        fill="white"
      />
      <path
        d="M8.49702 10.7065C8.82761 10.7065 9.09561 10.4385 9.09561 10.1079C9.09561 9.77727 8.82761 9.50928 8.49702 9.50928C8.16643 9.50928 7.89844 9.77727 7.89844 10.1079C7.89844 10.4385 8.16643 10.7065 8.49702 10.7065Z"
        fill="white"
      />
      <path
        d="M12.0849 10.7065C12.4155 10.7065 12.6835 10.4385 12.6835 10.1079C12.6835 9.77727 12.4155 9.50928 12.0849 9.50928C11.7543 9.50928 11.4863 9.77727 11.4863 10.1079C11.4863 10.4385 11.7543 10.7065 12.0849 10.7065Z"
        fill="white"
      />
      <path
        d="M13.8849 8.92837C13.5976 7.2224 12.1131 5.91748 10.3233 5.91748C8.50958 5.91748 6.55818 7.41993 6.71382 9.77836C8.19232 9.17379 9.3057 7.8569 9.62295 6.25269C10.4071 7.82697 12.0173 8.91041 13.8849 8.92837Z"
        fill="white"
      />
    </svg>
  </SvgIcon>
);

export default TopicChatIcon;
